import React from 'react'

const View = ()=>{
    return (
        <div>
            404
        </div>
    )
}

export default View